<mat-sidenav-container autosize="true">
  <mat-sidenav #sidenav mode="side" opened>
    <account [isExpanded]="isExpanded"></account>
    <mat-nav-list>
      <a mat-list-item routerLink="/welcome" routerLinkActive="active-list-item">
        <mat-icon>home</mat-icon>
        @if (isExpanded) {
          <span matLine class="menu-title">Home</span>
        }
      </a>
      <a mat-list-item routerLink="/section-configuration" routerLinkActive="active-list-item">
        <mat-icon>perm_media</mat-icon>
        @if (isExpanded) {
          <span matLine class="menu-title">Section configuration</span>
        }
      </a>
      <a mat-list-item routerLink="/management" routerLinkActive="active-list-item">
        <mat-icon>settings</mat-icon>
        @if (isExpanded) {
          <span matLine class="menu-title">Management</span>
        }
      </a>
      <a mat-list-item routerLink="/dead-letters" routerLinkActive="active-list-item">
        <mat-icon>report_gmailerrorred</mat-icon>
        @if (isExpanded) {
          <span matLine class="menu-title">Dead letters</span>
        }
      </a>
      <mat-list-item class="sidenav-expand-button" (click)="isExpanded = !isExpanded">
        @if (isExpanded) {
          <mat-icon>chevron_left</mat-icon>
        }
        @if (!isExpanded) {
          <mat-icon>chevron_right</mat-icon>
        }
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>